module.exports = __webpack_public_path__ + "img/tee.6d3ba034.jpg";